"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var defaultTheme = function defaultTheme() {
  return {
    appearance: {
      primary: {
        containerAppearance: 'primary',
        iconAppearance: 'secondary',
        inverseIcon: false,
        inverseText: false
      },
      secondary: {
        containerAppearance: 'secondary',
        iconAppearance: 'secondary',
        inverseIcon: false,
        inverseText: false
      },
      alt1: {
        containerAppearance: 'alt1',
        iconAppearance: 'secondary',
        inverseIcon: false,
        inverseText: true
      },
      alt2: {
        containerAppearance: 'alt2',
        iconAppearance: 'primary',
        inverseIcon: true,
        inverseText: true
      },
      alt3: {
        containerAppearance: 'alt3',
        iconAppearance: 'primary',
        inverseIcon: true,
        inverseText: true
      }
    }
  };
};

var _default = defaultTheme;
exports["default"] = _default;
//# sourceMappingURL=LinkCard.theme.js.map